<template>

        <div>

            <!-- show loading indicator -->
		    <loading-indicator :loading="isLoading"></loading-indicator>

			<template v-if="!isLoading">

                <v-client-table ref="tblDocuments" name="tblDocuments" :data="table.tblData" :columns="['HC Marketing', 'Administrator', 'Administrator JTM'].indexOf(activeUser.userRole.name) > -1 ? table.tblColumns : table.tblColumnsDefault" :options="table.tblOptions" class="tbl-documents noFirstColumn">

					<!-- before table: FILTER OPTIONS -->
	                <template slot="beforeTable">

						<div class="is-pulled-left">

							<div class="columns is-marginless filters">

                                <!-- CHANNELS -->
                                <div class="column">
                                    <form-input inputType="select" :selectOptions="optionsChannels" label="CALENDAR-FILTER-CHANNEL" v-model="filterChannel" :selectAllowEmpty="true" :showLabel="true" :showLabelInOptions="true"></form-input>
                                </div>

	                    	</div>
						</div>

                        <div class="is-pulled-right" v-if="apoId == null">

                            <span class="button" @click="itemAdd()">
                                <span class="icon is-small">
                                    <i class="icon-ak-hinzufuegen"></i>
                                </span>
                                <lang labelKey="CALENDAR-DOCUMENTS-UPLOAD"></lang>
                            </span>

                        </div>

	                </template>

					<!-- marketingChannel -->
					<template slot="marketingChannel" slot-scope="props">
                        {{ $t('CALENDAR-MARKETING_CHANNEL-' + props.row.marketingChannel.name) }}
					</template>

					<!-- title  -->
					<template slot="title" slot-scope="props">
                        {{ props.row.title }}
					</template>

                    <!-- description  -->
					<template slot="description" slot-scope="props">

                        <popover trigger="hover" :content="props.row.description" placement="top">
                            <span style="display: block; width: 120px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">{{ props.row.description }}</span>
                        </popover>

					</template>

					<!-- format -->
					<template slot="format" slot-scope="props">
                        <span class="fileFormat">{{ getExtension(props.row.asset.filename) }}</span>
					</template>

                    <!-- uploaded -->
                    <template slot="uploaded" slot-scope="props">
                        {{ formatDate2(props.row.asset.updated, true) }}
					</template>

					<!-- download -->
					<template slot="download" slot-scope="props">

                        <!--
                        <a :href="$config.assets + props.row.asset.path + '/' + props.row.asset.filename" :download="props.row.asset.uploadFilename" class="dl" @click.stop="itemDownload(props.row)">
                            <span class="icon is-small">
                                <i class="icon-ak-download"></i>
                            </span>
                        </a>
                        -->
                        <span class="icon is-small" @click.stop.prevent="itemDownload(props.row)">
                            <i class="icon-ak-download"></i>
                        </span>

					</template>

                    <!-- delete -->
                    <template slot="delete" slot-scope="props">

                        <span class="icon is-small" @click.stop.prevent="itemDelete(props.row)">
                            <i class="icon-ak-entfernen"></i>
                        </span>

                    </template>


				</v-client-table>


                <!-- MODAL -->
                <modal
                    :width="modal.width"
                    :title="modal.title"
                    transition="fadeDown"
                    cancel-text="Abbrechen"
                    :show-ok="false"
                    :backdrop-closable="false"
                    :is-show="showModal"
                    @close="closeModal">

                        <template v-if="modal.isLoading">
                            <loading-indicator></loading-indicator>
                        </template>

                        <template v-else>

                            <template v-if="modal.type == 'edit'">

                                <form-input inputType="select" label="CALENDAR-CHANNEL" :selectOptions="marketingChannels" :selectAllowEmpty="true" :showLabel="true" :showLabelInOptions="true" isHorizontal="true" v-model="tmpItem.marketingChannel"></form-input>

                                <form-input inputType="text" label="DOCUMENT-TITLE" v-model="tmpItem.title" :isHorizontal="true"></form-input>

                                <div class="control is-horizontal">

                                    <div class="control-label">
                                        <label-name labelKey="DOCUMENT-VISIBILITY"></label-name>
                                    </div>

                                    <div class="control">
                                        <p-radio name="siteVisibility" v-model="tmpItem.siteVisibility" value="all">Alle</p-radio>
                                        <p-radio name="siteVisibility" v-model="tmpItem.siteVisibility" value="specific">Bestimmte Apotheke</p-radio>
                                    </div>

                                </div>


                                <div class="control is-horizontal" v-if="tmpItem.siteVisibility == 'specific'">

                                    <div class="control-label"></div>

                                    <div class="control">

                                        <template v-if="!pharmaciesLoaded">
                                            <loading-indicator-small></loading-indicator-small>
                                        </template>

                                        <template v-else>

                                            <multiselect
                                                v-model="tmpItem.site"
                                                :options="pharmacies"
                                                :custom-label="customLabel"
                                                :allow-empty="true"
                                                selected-label="aktiv"
                                                deselect-label="Klick um abzuwählen"
                                                select-label="Klick für Auswahl"
                                                placeholder="Suche nach Apotheke"
                                                label="name"
                                                track-by="id"
                                                :optionsLimit="10" style="margin-bottom:15px;" class="singleSelect is-default">
                                                    <span slot="noResult">Ihre Suche ergab leider keine Treffer.</span>
                                            </multiselect>

                                        </template>

                                    </div>

                                </div>

                                <form-input inputType="textarea" label="DOCUMENT-DESCRIPTION" v-model="tmpItem.description" :isHorizontal="true"></form-input>

                                <div class="control is-horizontal">

                                    <div class="control-label">
                                        <label-name labelKey="DOCUMENT-UPLOAD"></label-name>
                                    </div>
                                    <div class="control">

                                        <vue-dropzone
                                            :key="tmpItem.asset"
    										ref="vueDropzone"
    			                            id="vueDropzone"
    			                            url= "fileProcessing/upload?preset=marketingDocument"
    			                            :maxFiles="1"
    			                            dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Dokument hochladen"
    				                        v-on:vdropzone-success="dzSuccess"
                                            v-on:vdropzone-mounted="dzInit"
    			                            dzClass="default dzSingle">
    									</vue-dropzone>

                                    </div>

                                </div>


                                <div slot="footer">
                                    <span class="button" @click="closeModal">schließen</span>
                                    <span :class="['button is-success', { 'is-loading': modal.isSaving }, { 'is-disabled': !newItemFullfilled || tmpItem.asset == null } ]" @click="itemSave">speichern</span>
                                </div>

                            </template>


                        </template>

                </modal>


            </template>

        </div>

</template>


<script>
import Vue from 'vue';
import { ClientTable, Event } from 'vue-tables-2';
Vue.use(ClientTable, {}, false, 'bulma');

import vue2Dropzone from '../utils/dropzoneWrapper'

import PrettyRadio from 'pretty-checkbox-vue/radio';
Vue.component('p-radio', PrettyRadio);

export default {

    name: 'calendarTabDocuments',

    props: {

        pharmacy: {
			type: Object,
			default: null
		},
        /*
        apoId: {
            type: Number,
            default: null
        },
        */

    },

    components: {
        vueDropzone: vue2Dropzone,
    },

    watch: {

        filterChannel(ch) {

            Event.$emit('vue-tables.tblDocuments.filter::filter', {
                channel: this.filterChannel != null ? this.filterChannel.name : null
			});

        },

        'tmpItem.siteVisibility'(val) {
            if(val == 'specific') {
                this.fetchPharmacies();
            }
        }


    },

    computed: {

        apoId() {
			return this.site != null ? this.site.id : null;
		},

        marketingChannels() {

            var herbaServices = {};

            var chs = this.$store.getters.getTermsByTaxonomy('MARKETING_CHANNELS');
            // console.log("x: ", chs);

            for (var key in chs) {

                if (!chs.hasOwnProperty(key)) continue;

                var obj = chs[key];
                if(obj.data.category == 'HERBASERVICES') {
                    herbaServices[key] = obj
                }
            }

            return herbaServices;

        },

        marketingDocumentTypes() {
            return this.$store.getters.getTermsByTaxonomy('MARKETING_DOCUMENT_TYPES');
        },

        newItemFullfilled() {

            if(this.tmpItem.marketingChannel != null && this.tmpItem.title != "" && this.tmpItem.siteVisibility != "" && (this.tmpItem.siteVisibility == 'all' || this.tmpItem.site != '') ) {

                return true;

            } else {

                return false;

            }

        },

        calendarEntryTaskResponsibilityTypes() {
			return this.$store.getters.getTermsByTaxonomy('CALENDAR_ENTRY_TASK_RESPONSIBILITY_TYPES');
		},

    },

    data() {

        return {

            pharmacies: null,
            pharmaciesLoaded: false,

            site: null,

            isLoading: false,

            filterChannel: null,
            optionsChannels: null,

            modal: {
                width: '640',
                title: '',
                class: '',
                isSaving: false,
                isLoading: false,
            },

            showModal: false,

            tmpItem: {
                id: null,
                asset: null,
                marketingChannel: null,
                siteVisibility: '',
                site: '',
                title: '',
                description: '',
                type: ''
            },

            table: {

                tblData: [],
                tblColumns: ['marketingChannel', 'title', 'description', 'format', 'uploaded', 'download', 'delete'],
                tblColumnsDefault: ['marketingChannel', 'title', 'description', 'format', 'uploaded', 'download'],
                tblOptions: {
                    saveState: false,
                    perPage: 25,
                    orderBy: {
                        ascending: false,
                        column: 'uploaded'
                    },

                    columnsClasses: { format: 'format', uploaded: 'uploaded', download: 'download' },

                    // custom table headings - make them clickable for language Setting
                    headings: {

                        marketingChannel(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-MARKETING_CHANNEL"></lang>
                        },
                        title(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-TITLE"></lang>
                        },
                        description(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-DESCRIPTION"></lang>
                        },
                        format(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-FORMAT"></lang>
                        },
                        uploaded(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-UPLOADED"></lang>
                        },
                        download(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-DOWNLOAD"></lang>
                        },
                        delete(h) {
                            return <lang labelKey="CALENDAR-DOCUMENTS-TBL_HEADLINE-DELETE"></lang>
                        },
                    },

                    sortable: ['marketingChannel', 'uploaded'],
                    sortIcon: {
                        base:'fa',
                        up:'fa-sort-up',
                        down:'fa-sort-down',
                        is:'fa-sort'
                    },

                    filterByColumn: false,
                    filterable: false,

                    texts: {
                        filter: 'Filter Ergebnisse:',
                        filterPlaceholder: 'Suche',
                        limit: 'Einträge pro Seite',
                        noResults: 'keine passenden Einträge gefunden',
                        count: '{from} bis {to} von {count} Einträgen|{count} Einträge|ein Eintrag'
                    },

                    pagination: {
                        chunk: 5
                    },

                    skin: 'table is-striped is-hoverable is-fullwidth',


                    // custom filter functions
					customFilters: [
						{
						name: 'filter',

							callback(row, payload) {

                                // filter channel
                                if(payload.channel != null) {

                                    return row.marketingChannel.name == payload.channel;

                                } else {

                                    return true;

                                }

                            }

                        }

                    ]

                }

            }
        }


    },

    created() {

        this.site = this.pharmacy;
        this.fetchData();

    },

    mounted() {

        // handle click events on table rows
        Event.$on('vue-tables.tblDocuments.row-click', function (data) {

            // console.log("data.event.target.className: ", data.event.target.className);
            /*
            if(['dl', 'icon-ak-download'].indexOf(data.event.target.className) > -1) {
                return;
            }
            */

            if(['HC Marketing', 'Administrator', 'Administrator JTM'].indexOf(this.activeUser.userRole.name) > -1) {
                this.itemEdit(data.row);
            }

		}.bind(this));

    },

    methods: {


		dzSuccess(file) {

			var result = JSON.parse(file.xhr.response);

            // console.log("file: ", file);
            // console.log("result: ", result);

			this.tmpItem.asset = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			// remove image from dropzone after some time
			// var x = this.$refs.vueDropzone.$children[0];

            /*
			setTimeout(function() {
				x.removeFile(file);
			}, 1500)
            */

		},

        dzInit() {

            var self = this;

            if(this.tmpItem.asset == null) {
                return;
            }

            let ext = this.getExtension(this.tmpItem.asset.filename);


            // check if we've an image
            if(ext == 'jpg' || ext == 'jpeg' || ext == 'gif' || ext == 'png') {

                var url = self.$config.assets + this.tmpItem.asset.path + '/' + this.tmpItem.asset.filename;

            } else {

                // otherwise we display a predefined icon
                let extensions = ['ai', 'eps', 'indd', 'pdf', 'psd', 'tiff', 'tif', 'doc', 'docx', 'xls', 'xlsx', 'zip'];

                var url = extensions.indexOf(ext) > -1
                    ? require('../../assets/img/fileTypes/datei-'+ext+'.png')
                    : require('../../assets/img/fileTypes/datei-undefined.png');

            }

            // set the url
            // let url =  self.$config.assets + this.tmpItem.asset.path + '/' + this.tmpItem.asset.filename;
            var mockFile = { id: 'asset', name: this.tmpItem.asset.filename }

            // add mockFile to our dropzone
            self.$refs.vueDropzone.$children[0].manuallyAddFile(mockFile, url);

		},


        customLabel({ name, city, zipcode, extRef }) {

            return name + ' (#'+extRef+')';

        },

        itemDelete(row) {

            var index = this.table.tblData.findIndex(t => t.id == row.id);
            var self = this;

            this.entityDelete('marketingDocument', row.id, 'CALENDAR-DOCUMENT-DELETE')
                .then(response => {
                    self.table.tblData.splice(index, 1);
                    // self.fetchData();
                });

        },


        itemDownload(row) {

            let link = document.createElement('a');
            link.href = this.$config.assets + row.asset.path + '/' + row.asset.filename;
            link.download = row.asset.uploadFilename;
            document.body.appendChild(link);
            link.click();

            setTimeout( function () { link.parentNode.removeChild( link ); },10 );

        },


        itemAdd() {

            this.showModal = true;
            this.modal.type = "edit";
            this.modal.title = "Neues Dokument erstellen";


            this.showModal = true;

        },

        itemEdit(data) {

            this.modal.type = "edit";
            this.modal.title = "Dokument bearbeiten";

            this.tmpItem = {
                id: data.id,
                asset: data.asset,
                marketingChannel: data.marketingChannel,
                siteVisibility: data.site == null ? 'all' : 'specific',
                site: data.site,
                title: data.title,
                description: data.description,
                type: data.type
            },

            this.showModal = true;

        },

        itemSave() {

            this.modal.isSaving = true;

            if(this.tmpItem.siteVisibility == 'all') {
                this.tmpItem.site = null;
            }

            this.tmpItem.type = this.marketingDocumentTypes.DOWNLOAD.id;
            var self = this;

            this.entityCreateOrUpdate('marketingDocument', this.tmpItem)
                .then(response => {
                    self.modal.isSaving = false;
                    self.fetchData();
                });

            this.closeModal();

        },

        closeModal() {

            this.showModal = false;
            this.modal.isSaving = false;
            this.tmpItem = {
                id: null,
                asset: null,
                marketingChannel: null,
                siteVisibility: '',
                site: '',
                title: '',
                description: '',
            };

        },


        getExtension(filename) {

            return (filename.split('.').pop()).toLowerCase();

        },


        fetchData(initial=true) {

            if(initial) {
                this.isLoading = true;
            }


            //let url = this.$config.api + 'marketingDocument?include=marketingDocument.site,marketingDocument.type,marketingDocument.marketingChannel,marketingDocument.asset&filters[type.name]=download&showMetafields=1';
            let url = this.$config.api + 'marketingDocument/downloads';
            /*
            if(this.apoId != null) {
                url += '&filters[site]=null,'+this.apoId;
            }
            */
            // url += '?filters[site]='+this.apoId != null ? this.apoId : 'null';

            var self = this;


            this.axios.get(url)
                .then(response => {

                    if(initial) {

                        var channels = [];
                        // add channel as option to the dropdown
                        response.data.marketingDocument.forEach(doc => {
                            if(channels.findIndex(ch => ch.name == doc.marketingChannel.name) == -1) {
                                channels.push( { name: doc.marketingChannel.name } );
                            }
                        })

                        self.optionsChannels = channels;
                    }

                    self.table.tblData = response.data.marketingDocument;
                    self.isLoading = false;

                    // console.log(self.table.tblData);


                });


        },

        fetchPharmacies() {

			var self = this;

            this.axios.get(self.$config.api + 'site?orderBy=name&fields=name,extRef,mandate,marketingPlan')
				.then(response => {

				    self.pharmacies = response.data.site;
                    self.pharmaciesLoaded = true;

				}).catch(function(error) {
					console.log('Error: ', error.message);
				});

		}

    }

}

</script>


<style lang="scss">
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
</style>

<style scoped>

    .tbl-documents >>> th:first-child {
        width: 175px;
    }

    .tbl-documents >>> th.format {
        width: 120px;
    }
    .tbl-documents >>> th.uploaded {
        width: 200px;
    }
    .tbl-documents >>> th.download {
        width: 75px;
    }

    .tbl-documents >>> th:last-child {
        width: 75px;
    }

    .tbl-documents >>> td .icon {
        height: 20px;
        width: auto;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 0;
    }
    .tbl-documents >>> a.dl {
        border: none !important;
        color: #000;
    }

    .fileFormat {
        text-transform: uppercase;
    }
</style>
